<app-header *ngIf="!isFranchisee"></app-header>
<div class="main-container">
  <div [ngClass]="!isFranchisee?'container-fluid pt-3 mb-3 pb-3':'container-fluid pt-3'">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer *ngIf="!isFranchisee"></app-footer>
